import { render } from "./ArticleEditor.vue?vue&type=template&id=b171a578"
import script from "./ArticleEditor.vue?vue&type=script&lang=js"
export * from "./ArticleEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__